import { Action } from '@/_core/fluxstore/types';
import { NotificationSettingsState } from '../types';
import { useNotificationSettingsStore } from '../useModule';
import { UserNotificationSettings } from '@/api/notification-settings/queries';
import { useSendCommand } from '@/_core/cqrs/use';
import { UpdateUserNotificationSettingsCommand } from '@/api/notification-settings/commands';

const { registerMiddleware, registerReducer } = useNotificationSettingsStore();

export class UpdateUserNotificationSettings extends Action<NotificationSettingsState> {
    public static ACTION_TYPE = 'UpdateUserNotificationSettings';
    public constructor(public settings: UserNotificationSettings) {
        super(UpdateUserNotificationSettings.ACTION_TYPE);
    }
}

const middleware = async (state: NotificationSettingsState, action: UpdateUserNotificationSettings): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new UpdateUserNotificationSettingsCommand(action.settings),
    });
};

const reducer = (state: NotificationSettingsState, action: UpdateUserNotificationSettings): void => {
    state.id = action.settings.Id;
    state.autoWatchMyCards = action.settings.AutoWatchMyCards;

    state.changeRights.mapFrom(action.settings.ChangeRights);
    state.firstTimeVisitedMyBoard.mapFrom(action.settings.FirstTimeVisitedMyBoard);
    state.invitedMe.mapFrom(action.settings.InvitedMe);
    state.someoneCommentedOrChangedWatchedCards.mapFrom(action.settings.SomeoneCommentedOrChangedWatchedCards);
    state.someoneMentionedMe.mapFrom(action.settings.SomeoneMentionedMe);
    state.someonePostedOnBoardDiscussions.mapFrom(action.settings.SomeonePostedOnBoardDiscussions);
};

//@ts-ignore
registerMiddleware(UpdateUserNotificationSettings.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UpdateUserNotificationSettings.ACTION_TYPE, reducer);
